import styled from "styled-components"
import { MainFrame, MainHeadingCapital, MainText } from "../../../components/01_config/MainStyles"
import { colors } from "../../../components/01_config/Colors"
import { sizes } from "../../../components/01_config/Sizes"

const FrameContent = styled(MainFrame)`
    width: 600px;
    flex-direction: column;
    gap: 50px;
    padding: 50px;
    margin: ${sizes.sections_gap_desk} auto;
    align-items: start;
`

const FrameHeading = styled(MainHeadingCapital)`
    margin: 0 auto;
    color: ${colors.myprogress};
    font-weight: bold;
    font-size: 1.4rem;
`
const LessonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    max-height: 550px;
    gap: 10px;
    text-align: center;
    width: 50%;
`

const Text = styled(MainText)`
    width: 100%;
    white-space: pre-wrap;
    cursor: pointer;
    &:hover {
        color: ${colors.headingColor};
    };
        &:active {
        background-color: lightblue;
    }
`

export { FrameContent, FrameHeading, LessonsWrapper, Text }